import { render, staticRenderFns } from "./Son_UPFCheckBox.vue?vue&type=template&id=aa8e4978&scoped=true&"
import script from "./Son_UPFCheckBox.vue?vue&type=script&lang=js&"
export * from "./Son_UPFCheckBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa8e4978",
  null
  
)

export default component.exports